import React from 'react';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteVisits } from '../../../redux/visits/actions/visits.action';
import { AppDispatch } from '../../../redux/rootReducer';
import iconClose from '../../../images/icon-close.svg';
import styles from './DeleteAppointmentModal.module.css';
import { Controller, useForm } from 'react-hook-form';
import TextInput from '../input/textInput/TextInput';

interface FormData {
	reason: string;
}

const DeleteAppointmentModal = ({ calendarInfo, setShowDeleteModal, locationId ,startDate,endDate}: AnyIfEmpty<object>) => {

	const navigate = useNavigate();
	const dispatch: AppDispatch = useDispatch();

	const { control, handleSubmit, formState: { errors }, watch } = useForm<FormData>();

	const closeModal = () => setShowDeleteModal(false);

	// const deleteAppointments = () => {
	// 	dispatch(deleteVisits(calendarInfo.appointmentId, locationId));
	// 	closeModal()
	// };

	const reason = watch('reason');

	const onSubmit = (data: FormData) => {
		dispatch(deleteVisits(calendarInfo.appointmentId, locationId, data.reason,startDate,endDate));
		closeModal();
	};

	return (
		<>
			<div className={styles.modalRemoveStaff}>
				<div className={styles.modalHeader}>
					<div className={styles.modalTitle}>Delete Appointment</div>
					<span className={styles.close}>
						<img src={iconClose} onClick={closeModal} alt="Close" />
					</span>
				</div>

				<form onSubmit={handleSubmit(onSubmit)}>
					<div className={styles.modalBody}>
						<h2 className={styles.modalBodyTitle}>Are you sure you want to cancel this appointment?</h2>
						<p className={styles.modalBodyInfo}>This appointment will be cancelled. Another one can be booked.</p>

						<Controller
							name="reason"
							control={control}
							defaultValue=""
							rules={{ required: 'Reason is required' }}
							render={({ field }) => (
								<TextInput
									{...field}
									id="reason"
									className={styles.textarea}
									placeholder="Enter reason for cancellation"
								/>
							)}
						/>
					</div>

					<div className={styles.modalFooter}>
						<button onClick={closeModal} className={`${styles.Modalbtn} ${styles.cancelBtn}`}>
							Cancel
						</button>
						<button type='submit' disabled={(reason === null || reason?.trim() === '')} className={`${styles.Modalbtn} ${styles.deleteBtn}`}>
							Delete
						</button>
					</div>
				</form>
			</div>
		</>
	);
};

export default DeleteAppointmentModal;
